var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.show,
        "with-header": false,
        direction: "rtl",
        size: "35%",
      },
      on: {
        open: _vm.open,
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c(
        "el-table",
        { staticClass: "studentTable", attrs: { data: _vm.dataList } },
        [
          _c("el-table-column", {
            attrs: { property: "name", label: "姓名", width: "150" },
          }),
          _c("el-table-column", {
            attrs: { property: "loginName", label: "登录名", width: "200" },
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pagination.currentPage,
          "page-sizes": _vm.pagination.pageSizes,
          "page-size": _vm.pagination.pageSize,
          layout: _vm.pagination.layout,
          total: _vm.pagination.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }